<template>
  <div class="map-legend">
    <div class="map-legend-content">
      <template v-for="(layer) in layers">
        <MapLegendLayer
          v-if="layer?.properties?.legend?.length"
          :collapsed-layers="collapsedLayers"
          :layer="layer"
          @toggle="toggleCollapse"
        />
      </template>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import MapLegendLayer from "@/components/content/MapLegendLayer.vue";
import {MapEvent} from "@/js/document/model/map";
import EventBus from '@/js/event-bus';

export default defineComponent({
  name: "MapLegendDialog",
  inject: ['dialogRef'],
  components: {MapLegendLayer},
  props: ['controller'],
  data() {
    return {
      mapController: undefined,
      collapsedLayers: [],
      layers: [],
      iframe: undefined
    }
  },
  mounted() {
    this.mapController = this.dialogRef?.data?.mapController || this.controller;
    this.iframe = this.mapController?.configuration?.iframeProperties;
    this.buildLayers();

    this.mapController.mapInstance.on(MapEvent.LayersChange, ()=>{
      this.buildLayers();
      if(!this.layers.length){
        this.dialogRef?.close();
      }
    })

    this.mapController.mapInstance.on(MapEvent.VisibleLayerListChanged, ()=>{
      this.buildLayers();
      if(!this.layers.length){
        this.dialogRef?.close();
      }
    })

    if (this.iframe?.settings?.legendIsCollapsed) {
      this.collapsedLayers = this.layers.map(item => item.documentId);
    }
  },
  methods: {
    buildLayers(){
      this.layers = this.mapController.getLayers().filter(layer => layer?.properties?.legend?.length && !this?.mapController?.isLayerHidden(layer)).reverse();

      if (this?.iframe?.properties?.visibleLayers?.length) { // sort layers by visibleLayers(which is flat) order
        this.layers = this.layers.sort((a, b) => this.iframe.visibleLayers.indexOf(a.documentId) - this.iframe.visibleLayers.indexOf(b.documentId));
      }

      EventBus.emit('handle-stamp-print-from-legend')
    },
    isCollapsed(layer) {
      return this.collapsedLayers.indexOf(layer.documentId) > -1
    },
    toggleCollapse(layer) {
      if (!this.isCollapsed(layer)) {
        this.collapsedLayers.push(layer.documentId)
      } else {
        this.collapsedLayers = this.collapsedLayers.filter(l => l !== layer.documentId)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.map-legend {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--surface-0);
  color: var(--text-color);
  pointer-events: auto;

  .map-legend-title {
    font-weight: bold;
    padding: 5px 10px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: move;
  }

  .map-legend-close {
    cursor: pointer;
    font-size: large;
  }

  .map-legend-content {
    max-height: calc(100% - 31px);
    overflow: hidden auto;
    font-size: 12px;
  }
}
</style>
